import useNavigateWithTransition from '@/hooks/useNavigateWithTransition';
import LikeButton from '@/shared-components/buttons/components/LikeButton';
import ViewsIcon from "@/shared-components/icons/components/user-profile/ViewsIcon";
import Text from "@/shared-components/text/components/Text";
import Utils from "@/utils";

import './styles/PostInfo.css';

export default function PostInfo({ fetchData }) {

  const navigateWithTransition = useNavigateWithTransition();

  const onUserNameClick = () => {
    const galleryName = fetchData.gallery.user_username;
    navigateWithTransition(`/user/${galleryName}`, { state: { from: true } });
  };

  return (
    <>
      <h1 className="post__title">
        {fetchData.post_container.post_title}
      </h1>

      <div className="post__info">
        <div className="post__info-date-user">

          <Text className="post__info-date" small>
            {Utils.getDateInStringFromTimestamp(new Date(fetchData.createdAt).getTime())}
          </Text>

          <div className="post__info-separator" />

          <Text className="post__info-user" small onClick={onUserNameClick}>
            {fetchData.gallery.user_username}
          </Text>
        </div>
        <div className='post__info_icons-container'>
          <Text className="post__info-views" small>
            {Utils.numberParserMillionThousand(fetchData.post_visits)}
            <ViewsIcon className="post__info-views-icon" />
          </Text>
          <LikeButton
            itemId={fetchData._id}
            typeOfItem="POST"
            isLiked={fetchData.is_liked}
            className=" ml-3 h-[18px] "
          />
        </div>
      </div>

      <Text className="post__main-text" paragraph justify medium>
        {fetchData.post_container.post_main_text}
      </Text>
    </>
  );
}
